import React, { Suspense, useState, useEffect, useMemo } from 'react';
import { View } from 'react-native';
import MultiFeatureCard from '../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import TreeMapWrapper from './TreeMapWrapper';
import { transformTreeMapData } from './utils';
import useFetchAiAnalyticsWidgetData from '../../../hooks/useFetchAiAnalyticsWidgetData';
import GenericNoData from '../../../../../components/Common/NoData/GenricNoData';

const TopicsBreakout = props => {
  const { itemData, timeperiodLabel, applied_filter_values } = props;
  const [transformedData, setTransformedData] = useState([]);

  const { data, isLoading } = useFetchAiAnalyticsWidgetData({
    widgetId: itemData?.widgetId,
    appliedFilterValues: applied_filter_values,
    widget_config: {}
  });

  useEffect(() => {
    if (isLoading) return;

    try {
      if (!data?.rows?.length || !data?.hierarchy?.length) {
        setTransformedData([]);
        return;
      }
      setTransformedData(transformTreeMapData(data));
    } catch (e) {
      setTransformedData([]);
    }
  }, [data, isLoading]);

  const shouldRender = !isLoading && transformedData.length > 0;

  return (
    <View>
      <MultiFeatureCard
        title={itemData?.title || 'Mention Breakout By Topic'}
        subTitle={timeperiodLabel}
        loading={isLoading}
        style={{ childContainer: { minHeight: 250 } }}
        isNoData={!isLoading && !transformedData.length > 0}
        renderContent={() =>
          (shouldRender && !isLoading) ? (
            <Suspense fallback={null}>
              <TreeMapWrapper topics_hierarchy_data={transformedData} />
            </Suspense>
          ) : (
            null
          )
        }
      />
    </View>
  );
};

export default TopicsBreakout;